export default "https://failover.smartmove.systems";
// export default "https://i5e86mwx76.execute-api.ap-southeast-2.amazonaws.com/Stage";
// export default "http://127.0.0.1:3001";
